import { FC } from 'react';
import { Tooltip } from '@mui/material';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import PhoneIcon from '@mui/icons-material/Phone';
import SmsIcon from '@mui/icons-material/Sms';
import CustomerDataActions from './components/Actions';
import CustomerDataHost from './components/Host';
import useIsMobile from 'src/hooks/useIsMobile';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { IOrderFetch } from 'src/models/IOrder';
import './styles.scss';

interface IProps {
  order: IOrderFetch;
}

const CustomerData: FC<IProps> = ({ order }) => {
  const isMobile = useIsMobile();
  const { role } = useTypedSelector(state => state.auth);
  const { id, client, status } = order;
  const { first_name, last_name, phone, email, business_name } = client;

  return (
    <>
      <div className='order-show__title'>
        Guest
        <CustomerDataActions id={id} client={client} status={status} />
      </div>
      <div className='order-contact'>
        <div className='order-contact__item'>
          <div className='order-contact__item__title'>Name</div>
          <div className='order-contact__name'>
            {first_name} {last_name}
          </div>
        </div>
        {business_name && (
          <div className='order-contact__item'>
            <div className='order-contact__item__title'>Business/Org</div>
            <div>{business_name}</div>
          </div>
        )}
        <div className='order-contact__item'>
          <div className='order-contact__item__title'>Phone</div>
          <div className='order-contact__phone'>
            <div>{phone}</div>
            {isMobile && (
              <a href={`tel:${phone}`}>
                <PhoneIcon />
              </a>
            )}
            <a
              href={
                isMobile
                  ? `sms:${phone}`
                  : `https://voice.google.com/u/0/messages?itemId=t.%2B${phone}`
              }
              target={isMobile ? '_self' : '_blank'}
            >
              <SmsIcon />
            </a>
          </div>
        </div>
        <div data-title={email} className='order-contact__item' key={email}>
          <div className='order-contact__item__title'>email</div>
          <div className='order-contact__phone'>
            {<div>{email}</div>}
            {role === 'admin' && (
              <Tooltip title='Redirect to Gmail'>
                <a
                  href={`https://mail.google.com/mail/?view=cm&source=mailto&to=${email}&su=van trip ${id} needs you`}
                  target='_blank'
                >
                  <AttachEmailIcon />
                </a>
              </Tooltip>
            )}
          </div>
        </div>
        <CustomerDataHost order={order} />
      </div>
    </>
  );
};

export default CustomerData;
